export default __webpack_public_path__ + "img/230d01ad840ffb771fe673cd9dd3dc16.png";